export const HoneMark = ({ className }: { className?: string }) => (
  <svg
    viewBox="0 0 63.135 46.333"
    fill="none"
    className={className}
    aria-hidden
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M 31.566 0 L 0 46.322 L 63.135 46.333 L 31.566 0 Z M 41.772 29.858 C 35.664 25.379 27.457 25.379 21.352 29.858 L 8.828 39.04 L 28.382 17.524 C 29.191 16.628 30.349 16.117 31.562 16.117 C 32.775 16.117 33.935 16.631 34.743 17.526 L 54.302 39.047 L 41.772 29.858 Z M 54.894 41.831 L 49.293 39.629 C 37.854 35.134 25.258 35.134 13.819 39.629 L 8.241 41.822 L 22.473 31.388 C 27.909 27.4 35.216 27.4 40.655 31.388 L 54.898 41.833 L 54.894 41.831 Z M 14.511 41.392 C 25.502 37.073 37.608 37.073 48.599 41.392 L 56.34 44.437 L 6.781 44.428 L 14.509 41.392 L 14.511 41.392 Z M 52.927 34.718 L 36.146 16.254 C 34.979 14.963 33.307 14.223 31.559 14.223 C 29.812 14.223 28.14 14.963 26.975 16.254 L 10.21 34.702 L 31.566 3.364 L 52.927 34.718 Z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </svg>
);
